var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grav-container rounded-full"},[_c('div',{staticClass:"top rounded-full border-2 border-white"},[_c('div',{staticClass:"rounded-full",class:_vm.computedClass,style:({
        backgroundImage: `url(${_vm.computedImage})`,
        backgroundSize: 'cover',
        width: `${_vm.size}px`,
        height: `${_vm.size}px`
      })})]),_c('div',{staticClass:"bottom border-2 border-white rounded-full"},[_c('span',{staticClass:"centered text-white font-semibold pb-px tracking-wide"},[_vm._v(_vm._s(_vm.computedInitials))]),_c('div',{staticClass:"rounded-full w-full h-full",class:_vm.computedInitials === '?' ? 'bg-grey-dk' : 'bg-copy'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }